import { IncomeConfirmationModalTexts } from '../IncomeConfirmationModal.texts';

import { getEsiaExactTermsBenefit } from './getEsiaExactTermsBenefit';

export const getEsiaApplicationBenefits = (bankName: string, mplCount: number) => [
  getEsiaExactTermsBenefit(bankName, mplCount),
  IncomeConfirmationModalTexts.esiaBenefitFinalTerms,
  IncomeConfirmationModalTexts.esiaBenefitNoCalls,
  IncomeConfirmationModalTexts.esiaBenefitTermsFor30Days,
];
